import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import AdvantagesSection from './components/AdvantagesSection';
import GallerySection from './components/GallerySection';
import VideoSection from './components/VideoSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

const HomePage = () => (
  <div className="bg-[#0a0a0a] min-h-screen">
    <Navbar />
    <main>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <AdvantagesSection />
      <GallerySection />
      <VideoSection />
      <CTASection />
    </main>
    <Footer />
    <WhatsAppFloat />
  </div>
);

export default HomePage;